<template lang="pug">
  md-card
    md-card-header(data-background-color="green")
      h4(class="title") Your Analyst Group
      p(class="category") General Information for your Analyst Group
    md-card-content(style="text-align: center;")
      md-table
        md-table-row
          md-table-cell <b>Lead Senior Analysts</b>
          md-table-cell
            span(v-for="(name, index) in groupData.senior_analysts") 
              span {{name}}
              span(v-if="index != groupData.senior_analysts.length - 1") , &nbsp
        md-table-row
          md-table-cell <b>Meeting Time</b>
          md-table-cell {{groupData.day}} @ {{groupData.hour - 12}} pm
        md-table-row
          md-table-cell <b>Location</b>
          md-table-cell {{groupData.location}}
      iframe(:src="groupData.map_url" style="border:0; height: 275px; width: 550px; margin-top: 20px;" allowfullscreen="")
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      user: null,
      groupData: null,
      error: null,
    }
  },
  props: {
    groupID: {
      type: Number,
      default: null
    }
  },
  mounted() {
    this.user = this.$store.state.user;
    this.getGroupInformation();
  },
  methods: {
    getGroupInformation() {
      axios.get(`/api/org/analyst_groups/${this.groupID}`)
      .then((res) => {
        this.groupData = res.data;
      }).catch((err) => {
        this.error = true;
      })
    }
  }
}
</script>

<style scoped>
  p {
    font-style: italic;
  }
</style>


// WEBPACK FOOTER //
// src/pages/AnalystGroup/AnalystGroupOverview.vue